import React from "react";
import ParticleBackground from "../../particleBackground";

function Achievements() {
  return (
    <div id="achInt">
      <div id="head">
        <h1>Achievements & Interests</h1>
      </div>

      <div class = "main-container">

        <div className="text-wrap left">
          <div className="content">
            <h1>CGPA</h1>
            <p>First Year : 9.58</p>
          </div>
        </div>

        <div className="text-wrap right">
          <div className="content r">
            <h1>Piano</h1>
            <p>I am paino player since 4th standard.</p>
          </div>
        </div>

        <div className="text-wrap left">
          <div className="content">
          <h1>+2 HP Board</h1>
            <p>98.6% || 5th Rank in State</p>
          </div>
        </div>

        <div className="text-wrap right">
          <div className="content r">
            <h1>Sketching</h1>
            <p>I love pencil sketching as a recreational activity.</p>
          </div>
        </div>

        <div className="text-wrap left">
          <div className="content">
            <h1>8th Standard</h1>
            <p><b>2nd position</b> at <em>state level</em> Children Science National Congress Quiz Competition</p>
          </div>
        </div>

        <div className="text-wrap right">
          <div className="content r">
            <h1>Reading</h1>
            <p>I love to read fiction novels.</p>
          </div>
        </div>

        <div className="text-wrap left">
          <div className="content">
            <h1>SJVN Declamation</h1>
            <p>Bagged <b>1st position</b> in a declamation competition held by <em>SJVN Limited.</em></p>
          </div>
        </div>

        <div className="text-wrap right">
          <div className="content r">
            <h1>Music</h1>
            <p>I love listening to slowed and reverbed songs because their beats maintain my work tempo.</p>
          </div>
        </div>

        <div className="text-wrap left">
          <div className="content">
            <h1>Olympiads</h1>
            <p>Cleared zonal level olympiads in my 8th, 9th and 10th standards.</p>
          </div>
        </div>

    

      </div>

    </div>
  );
}

export default Achievements;
